<template>
    <div>
      <el-steps :active="step" finish-status="success" class="mb-2 static-css">
        <el-step title="" icon="el-icon-set-up"></el-step>
        <el-step title="" icon="el-icon-mobile-phone"></el-step>
        <el-step title="" icon="el-icon-lock"></el-step>
      </el-steps>
      <div v-if="step === 0">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.double_factor_label')}}</p>
        <base-el-select :options="tiposOtp" class="w-full mt-2" v-model="tipoAcceso" filterable />
      </div>
      <div v-else-if="step === 1 && tipoAcceso == 3">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.download_authenticator_label')}}</p>
        <base-el-select :options="tiposPlataforma" class="w-full mt-2" v-model="tipoPlataforma" filterable />
        <div class="flex mt-2 w-full justify-center">
          <a v-if="tipoPlataforma == 0" href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" >
            <img :src="PlayStoreQR" alt="MicrosoftAutenticatorPlayStoreQR" class="max-h-56"/>
          </a>
          <a v-if="tipoPlataforma == 1" href="https://apps.apple.com/es/app/microsoft-authenticator/id983156458" target="_blank" >
            <img :src="AppStoreQR" alt="MicrosoftAutenticatorAppStoreQR" class="max-h-56"/>
          </a>
        </div>
      </div>
      <div v-else-if="step === 2 && tipoAcceso == 3">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.qr_scann_label')}}</p>
        <div class="flex mt-2 w-full justify-center">
          <img :src="'data:image/png;base64,' + b64Qr" alt="QRCode" class="max-h-56"/>
        </div>
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200 mt-2">{{$t('noauth.request_app_code_label')}}</p>
        <el-input
          :placeholder="$t('app.code')"
          type="codigo"
          class="mb-2 custom__icons mt-2 static-css"
          clearable
          v-model="otpLoginForm.codigo"
          maxlength='6'
        >
          <i slot="prefix" class="el-input__icon">
            <BaseIcon size="sm"  name="lock" />
          </i>
        </el-input>
      </div>
      <div v-else-if="step === 2 && tipoAcceso == 2">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.request_email_code_label')}}</p>
        <el-input
          :placeholder="$t('app.code')"
          type="codigo"
          class="mb-2 custom__icons mt-2 static-css"
          clearable
          v-model="otpLoginForm.codigo"
          maxlength='6'
          >
          <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm"  name="lock" />
          </i>
        </el-input>
      </div>
          <div class="flex mt-8">
              <base-button
                v-if="step > 0"
                class="mr-2"
                mode="staticprimary"
                :text="$t('app.back')"
                type="submit"
                :loading = "loader"
                @click="backStep()"
              />
              <base-button
                v-if="step < 2"
                :disabled="tipoAcceso == null"
                class="w-full"
                mode="staticprimary"
                :text="$t('app.next')"
                type="submit"
                :loading = "loader"
                @click="nextStep()"
              />
              <base-button
                v-else
                class="w-full"
                mode="staticprimary"
                :text="$t('noauth.common_access')"
                type="submit"
                :loading = "loader"
                @click="sendCode('otpLoginForm')"
              />
          </div>
    </div>
</template>

<script>
import AppStoreQR from '@/assets/img/qrcodes/AppStoreQR2.svg'
import PlayStoreQR from '@/assets/img/qrcodes/PlayStoreQR2.svg'
import { configOTP } from '@/services/auth/configOTP'
import { generateOTP } from '@/services/auth/generateOTP'

export default {
  name: 'otp-login-form',
  data: function () {
    return {
      loader: false,
      step: 0,
      tipoAcceso: '',
      tipoPlataforma: 0,
      b64Qr: '',

      PlayStoreQR: PlayStoreQR,
      AppStoreQR: AppStoreQR,

      otpLoginForm: {
        codigo: '',
      },
    }
  },
  computed: {
    tiposOtp: function () {
      return this.$store.getters['config/TIPOS_OTP']
    },
    tiposPlataforma: function () {
      return this.$store.getters['config/TIPOS_PLATAFORMA']
    },
  },
  methods: {
    backStep () {
      if (this.step === 2 && this.tipoAcceso === 2) {
        this.step--
      }
      this.step--
    },
    nextStep () {
      if (this.step === 0 && this.tipoAcceso === 2) {
        this.step++
      }
      this.enviarTipo()
      this.step++
    },
    enviarTipo: async function () {
      try {
        this.loader = true
        const tipoAcceso = this.tipoAcceso === 2 ? 'ECONF'
          : this.tipoAcceso === 3 ? 'OCONF'
            : null
        const response = await configOTP(tipoAcceso)
        if (response.blnError) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.generateOTP()
        }
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(`${error.msgError} [${error.codError}]`)
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    },
    generateOTP: async function () {
      try {
        this.loader = true
        const response = await generateOTP()
        if (response.blnError) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        }
        this.b64Qr = response.Base64QR
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(`${error.msgError} [${error.codError}]`)
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    },
    sendCode: async function () {
      try {
        this.loader = true
        await this.$store.dispatch('auth/checkOTPLogin', { otpCode: this.otpLoginForm.codigo })
        await this.$store.dispatch('app/getAnnouncementsList')
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(`${error.msgError} [${error.codError}]`)
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    }
  }
}
</script>
<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
